import { BackEndJob } from '@app/services/job-dispatcher/back-end-job';
import { SummitIdObject } from '@summit/models';
import { Ask } from '../digital-logs/asks/ask';
import { EProcess } from '../process/e-process';

export class StatusSync extends SummitIdObject {
  override id: never;
  inbox: EProcess[];
  askInProgress: Ask[];
  backEndJobs: BackEndJob[];

  constructor(data: Partial<StatusSync>) {
    super(data);
    if (data) {
      if (data.inbox) this.inbox = data.inbox.map((process) => new EProcess(process));
      if (data.askInProgress) this.askInProgress = data.askInProgress.map((ask) => new Ask(ask));
      if (data.backEndJobs) this.backEndJobs = data.backEndJobs.map((job) => new BackEndJob(job));
    }
    this.inbox ??= [];
    this.askInProgress ??= [];
    this.backEndJobs ??= [];
  }

  get inboxCount(): number {
    return this.inbox.length;
  }
  set inboxCount(value: number) {
    //no op
  }
}
